import { useEffect } from 'react';
import { values } from '../constants/defaults';

export interface priceProps {
  partNumber: string;
  pricingIndicator: string;
  pricingModel: number;
  scaleQtyPrice: [
    {
      qty: number;
      price: number;
    },
  ];
}

/**
 *
 * @param currentNumberOnPremHosts
 * @param currentMonthtlyCloudBill
 * @param currentCostOnPremHost
 * @param annualGrowthRateOnPremVM
 * @param annualGrowthRateCloudInstance
 * @param setShowContactUs
 * @param setRangeLow
 * @param setRangeHigh
 */
export const setPrice = (
  currentNumberOnPremHosts: number,
  currentMonthtlyCloudBill: number,
  currentCostOnPremHost: number,
  annualGrowthRateOnPremVM: number,
  annualGrowthRateCloudInstance: number,
  setShowContactUs: React.Dispatch<React.SetStateAction<boolean>>,
  setRangeLow: React.Dispatch<React.SetStateAction<number>>,
  setRangeHigh: React.Dispatch<React.SetStateAction<number>>,
  on_premVms: number,
) => {
  /**
   *
   */
  useEffect(() => {
    // 3-Year host density
    const currentVMDensity = on_premVms / currentNumberOnPremHosts;
    let value = Math.pow(1 + annualGrowthRateOnPremVM / 100, 3);
    const threeYearIncrementalHostsNeededAtCurrentDencisty =
      (on_premVms * value) / currentVMDensity - currentNumberOnPremHosts;
    // 3_Year incremental cost at current density
    const threeYearIncrementalCostofHostAtCurrentDensity =
      threeYearIncrementalHostsNeededAtCurrentDencisty * currentCostOnPremHost;
    // Projected Turbo VM: Host Density
    const projectedTurboVMHostDensity =
      currentVMDensity * (1 + values.assumedEfficiencyImprovement / 100);
    // 3-Year Incremental Hosts Needed Turbo Optimized
    value = Math.pow(1 + annualGrowthRateOnPremVM / 100, 3);
    const threeYearIncrementalHostsNeededOptimized =
      (on_premVms * value) / projectedTurboVMHostDensity -
      currentNumberOnPremHosts;
    // 3_year Incremental Cost of Hosts Optimezed
    const threeYearInclrementalCostOfHostsOptimezed =
      threeYearIncrementalHostsNeededOptimized * currentCostOnPremHost;
    // 3 Year Total Cloud Bill at Current Grouth Rate
    const year = 12 * currentMonthtlyCloudBill;
    value = 1 + annualGrowthRateCloudInstance / 100;
    const threeYearToatalCloudBillAtCurrentGrowthRate =
      year * value + year * Math.pow(value, 2) + year * Math.pow(value, 3);
    // 3-Year Total Cloud Bill Optimized
    const threeYearTotalCloudBillOptimized =
      threeYearToatalCloudBillAtCurrentGrowthRate *
      (1 - values.assumedEfficiencyImprovement / 100);
    // 3-Year Cost Avoidance from On_prem VM Density Increase
    const threeYearCostAvoidanceFromOnPremVMDensityIncrease =
      threeYearIncrementalCostofHostAtCurrentDensity -
      threeYearInclrementalCostOfHostsOptimezed;
    // 3-year Cost Avoidance from Cloud Bill Reduction
    const threeYearAvoidanceFromCloudBilReduction =
      threeYearToatalCloudBillAtCurrentGrowthRate -
      threeYearTotalCloudBillOptimized;
    // 3-Year Total Cost Avoidance
    const threeYearTotalCostAvoidnace =
      threeYearCostAvoidanceFromOnPremVMDensityIncrease +
      threeYearAvoidanceFromCloudBilReduction;
    const rangeLow = Math.round(threeYearTotalCostAvoidnace);
    const rangeHigh = Math.round(
      rangeLow / ((2 * values.assumedEfficiencyImprovement) / 100),
    );
    if (rangeLow <= 0) {
      setShowContactUs(true);
    } else {
      setRangeLow(rangeLow);
      setRangeHigh(rangeHigh);
      setShowContactUs(false);
    }
  }, [
    currentNumberOnPremHosts,
    currentMonthtlyCloudBill,
    currentCostOnPremHost,
    annualGrowthRateCloudInstance,
    annualGrowthRateOnPremVM,
    on_premVms,
  ]);
};
